import { render, staticRenderFns } from "./reg_office.vue?vue&type=template&id=09d56c0b&"
import script from "./reg_office.vue?vue&type=script&lang=js&"
export * from "./reg_office.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports